export default __webpack_public_path__ + "static/media/menegement_icon.9bc94161.svg";